import React from 'react';
import { Box, Circle, Icon } from '@chakra-ui/react';
import { IoDiamond } from 'react-icons/io5';
import { walletColors } from '../../../wallet/walletTheme';

/**
 * Glossy dark medallion with a warm glow behind it, matching the Diamond Creator modal
 * mockup — same disc treatment as the wallet hero card (walletColors.heroGradient).
 */
const DiamondIllustration: React.FC = () => (
  <Box position="relative" w="140px" h="140px" mx="auto">
    <Box
      position="absolute"
      inset="0"
      borderRadius="full"
      bg="radial-gradient(circle, rgba(251,191,36,0.35) 0%, rgba(251,191,36,0) 70%)"
      filter="blur(4px)"
    />
    <Circle
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      size="104px"
      bg={walletColors.heroGradient}
    >
      <Icon as={IoDiamond} boxSize={10} color="white" />
    </Circle>
  </Box>
);

export default DiamondIllustration;
